import { Accordion, Flex } from '@mantine/core';

import { TextInput } from '@components';

export const CustomsTradeSendReportSettings = ({ form, handleChange, editDisabled }) => {
  return (
    <Accordion.Item key="customsTradeSendReport" value="customsTradeSendReport">
      <Accordion.Control>Customs Trade Send Report</Accordion.Control>
      <Accordion.Panel>
        <Flex m="md" gap="md" wrap="wrap">
          <TextInput
            value={form.values.highValueSettings.sendReport.CTinvoiceHSCode}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTinvoiceHSCode');
            }}
            label="Invoice HS Code"
            w={160}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTcodeMatchStatus}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTcodeMatchStatus');
            }}
            label="Code match status"
            w={180}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTcodeMatchAccuracy100A}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTcodeMatchAccuracy100A');
            }}
            label="Code match accuracy 100A"
            w={220}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTcodeMatchAccuracy100B}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTcodeMatchAccuracy100B');
            }}
            label="Code match accuracy 100B"
            w={220}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTcodeMatchAccuracy100C}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTcodeMatchAccuracy100C');
            }}
            label="Code match accuracy 100C"
            w={220}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTcodeMatchAccuracy90}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTcodeMatchAccuracy90');
            }}
            label="Code match accuracy 90"
            w={220}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTinvoiceValue}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTinvoiceValue');
            }}
            label="Invoice value"
            w={130}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTwebPrice}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTwebPrice');
            }}
            label="Web price"
            w={120}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTpercentageWebPrice}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTpercentageWebPrice');
            }}
            label="Percentage Web price"
            w={150}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTstatisticalValue}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTstatisticalValue');
            }}
            label="Statistical value"
            w={150}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTreasonableValue}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTreasonableValue');
            }}
            label="Reasonable value"
            w={150}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTdutiesInvoiced}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTdutiesInvoiced');
            }}
            label="Duties Invoiced"
            w={150}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTdutiesMatchAccuracy100A}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTdutiesMatchAccuracy100A');
            }}
            label="Duties match accuracy 100A"
            w={250}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTpreferredHSCode}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTpreferredHSCode');
            }}
            label="Preferred HS Code"
            w={180}
            disabled={editDisabled}
          />
          <TextInput
            value={form.values.highValueSettings.sendReport.CTpreferredPrice}
            onChange={(event) => {
              handleChange(event.target.value, 'highValueSettings.sendReport.CTpreferredPrice');
            }}
            label="Preferred price"
            w={150}
            disabled={editDisabled}
          />
        </Flex>
      </Accordion.Panel>
    </Accordion.Item>
  );
};
